import { render, staticRenderFns } from "./item-inventory-filter.vue?vue&type=template&id=10555ec6&scoped=true"
import script from "./item-inventory-filter.vue?vue&type=script&lang=js"
export * from "./item-inventory-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10555ec6",
  null
  
)

export default component.exports